import { type VariantProps } from "class-variance-authority"
import * as React from "react"

import { cn } from "../../helpers"
import { badgeVariants } from "./badge.styled"

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {
  LeftIcon?: React.ReactNode
  RightIcon?: React.ReactNode
}

export const Badge = ({
  className,
  variant,
  LeftIcon,
  RightIcon,
  size,
  notification,
  disabled,
  ...props
}: BadgeProps) => {
  return (
    <div
      className={cn(badgeVariants({ variant, size, notification, disabled }), className)}
      {...props}
    >
      {LeftIcon ? LeftIcon : null}
      {props.children}
      {RightIcon ? RightIcon : null}
    </div>
  )
}
